// Maps theme CSS class/ID to the required Google Font family chunks.
// NOTE: Bricolage Grotesque is intentionally NOT listed here — it is the global
// display font and is self-hosted (see @font-face in app-globals.css + preload in
// index.html, HAB-144). Requesting it from Google again would double-load the same face.
export const THEME_FONTS: Record<string, string[]> = {
  "founders-edition": [
    "family=Cinzel:wght@400;500;600;700"
  ],
  "legacy-mode": [
    "family=Cinzel:wght@400;500;600;700"
  ],
  "aurora": [
    "family=JetBrains+Mono:wght@400;500;600",
    "family=Roboto+Mono:wght@400;600"
  ],
  "nebula": [
    "family=Sora:wght@400;500;600;700"
  ],
  "nebula-iridium": [
    "family=Sora:wght@400;500;600;700"
  ],
  "jade-dragon": [
    "family=Figtree:wght@300;400;500;600;700",
    "family=Cinzel:wght@400;500;600;700"
  ],
  "jade-dragon-aether": [
    "family=Figtree:wght@300;400;500;600;700",
    "family=Cinzel:wght@400;500;600;700"
  ],
  "mono": [
    "family=JetBrains+Mono:wght@400;500;600",
    "family=Roboto+Mono:wght@400;600"
  ],
  "paper": [
    "family=Rethink+Sans:wght@400;500;600;700"
  ],
  "zen-garden": [
    "family=Sora:wght@400;500;600;700",
    "family=Rethink+Sans:wght@400;500;600;700"
  ],
  "cyber-samurai": [
    "family=Figtree:wght@300;400;500;600;700",
    "family=Orbitron:wght@400;500;600;700;800;900"
  ],
  "cyber-samurai-onyx": [
    "family=Figtree:wght@300;400;500;600;700",
    "family=Orbitron:wght@400;500;600;700;800;900"
  ],
  "electric": [
    // Standard fonts, dynamically resolved in boot
  ],
  "laser": [
    "family=JetBrains+Mono:wght@400;500;600"
  ],
  "molten-pixel": [
    "family=Press+Start+2P",
    "family=VT323"
  ],
  "neon-grid": [
    "family=Orbitron:wght@400;500;600;700;800;900"
  ],
  "plasma": [
    "family=Rethink+Sans:wght@400;500;600;700"
  ],
  "synthwave": [
    "family=JetBrains+Mono:wght@400;500;600",
    "family=Roboto+Mono:wght@400;600"
  ],
  "forest-deep": [
    "family=Cinzel:wght@400;500;600;700"
  ],
  "mist": [
    "family=Sora:wght@400;500;600;700",
    "family=Rethink+Sans:wght@400;500;600;700"
  ],
  "ocean": [
    "family=Rethink+Sans:wght@400;500;600;700"
  ],
  "terra-firme": [
    "family=Sora:wght@400;500;600;700",
    "family=Rethink+Sans:wght@400;500;600;700"
  ],
  "golden-ratio": [
    "family=Orbitron:wght@400;500;600;700;800;900"
  ],
  "imperial-black": [
    "family=Cinzel:wght@400;500;600;700"
  ],
  "obsidian-bloom": [
    "family=Sora:wght@400;500;600;700",
    "family=Figtree:wght@300;400;500;600;700"
  ],
  "platinum-mist": [
    "family=Figtree:wght@300;400;500;600;700"
  ],
  "cassette": [
    "family=Rethink+Sans:wght@400;500;600;700",
    "family=Roboto+Mono:wght@400;600"
  ],
  "crt-soft": [
    "family=JetBrains+Mono:wght@400;500;600",
    "family=Roboto+Mono:wght@400;600"
  ],
  "polaroid": [
    "family=Sora:wght@400;500;600;700"
  ],
  "vaporwave": [
    "family=VT323"
  ],
  "blueprint": [
    "family=Roboto+Mono:wght@400;600",
    "family=JetBrains+Mono:wght@400;500;600"
  ],
  "mechanical-botanical": [
    "family=Roboto+Mono:wght@400;600"
  ],
  "opulence-era": [
    "family=Cinzel:wght@400;500;600;700"
  ],
  "shape-theory": [],
  "terminal": [
    "family=Rethink+Sans:wght@400;500;600;700"
  ],
  "skyline-code": [
    "family=Roboto+Mono:wght@400;600"
  ],
  "pop-pink": [
    "family=Cherry+Bomb+One"
  ],
  "bitcrush-sunset": [
    "family=Bangers",
    "family=Press+Start+2P"
  ]
};

const loadedFonts = new Set<string>();

export function loadThemeFonts(themeId: string) {
  if (typeof document === 'undefined') return;

  const required = THEME_FONTS[themeId];
  if (!required || required.length === 0) return;
  
  const toLoad = required.filter(f => !loadedFonts.has(f));
  if (toLoad.length > 0) {
    const families = toLoad.join('&');
    const url = `https://fonts.googleapis.com/css2?${families}&display=swap`;
    
    const link = document.createElement('link');
    link.href = url;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    
    toLoad.forEach(f => loadedFonts.add(f));
  }
}
